import { StoryNodeDisplayType } from "../../storyV2/domain/StoryNodeDisplayType";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
export class StoryNodeOptions {
    static getNodeType(type) {
        return StoryNodeType[type.toUpperCase()];
    }
    static getDisplayTypeType(type) {
        return StoryNodeDisplayType[type.toUpperCase()];
    }
    constructor(id, content, type, displayType, parentId = undefined, children = [], inputTitle = "", generatedLabel = "") {
        this.id = id;
        this.content = content;
        this.type = type;
        this.displayType = displayType;
        this.parentId = parentId;
        this.children = children;
        this.inputTitle = inputTitle;
        this.generatedLabel = generatedLabel;
    }
}
